import { render, staticRenderFns } from "./createStepTwo.vue?vue&type=template&id=8875517c&scoped=true"
import script from "./createStepTwo.vue?vue&type=script&lang=js"
export * from "./createStepTwo.vue?vue&type=script&lang=js"
import style0 from "./createStepTwo.vue?vue&type=style&index=0&id=8875517c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8875517c",
  null
  
)

export default component.exports